// extracted by mini-css-extract-plugin
export default {"page":"auth_page_page__kCJUs","logo":"auth_page_logo__Isvnz"};